// Official ritual-web-logo-kit.zip, copied without changing geometry or colors.
// Versioned URLs prevent an older cached EPS-derived wordmark from reappearing.
const asset = (name) => `/brand/${name}.svg?v=0859704f`;
export const RITUAL_BRAND = {
  wordmarks: {
    white: asset("ritual-wordmark-white"),
    olive: asset("ritual-wordmark-olive"),
    black: asset("ritual-wordmark-black"),
    width: 700, height: 153,
    viewBoxWidth: 157.35, viewBoxHeight: 34.43,
  },
  lockups: {
    white: asset("ritual-cafe-lockup-white"),
    olive: asset("ritual-cafe-lockup-olive"),
    black: asset("ritual-cafe-lockup-black"),
    width: 700, height: 244,
    viewBoxWidth: 157.35, viewBoxHeight: 54.84,
  },
  olive: "#3D4631",
  ecru: "#F1E9DC",
  faviconStatus: "awaiting-official-r",
};